import React from 'react'
import { string, shape } from 'prop-types'

const BannerStatic = ({
  link,
  trackingCode,
  imageAlt,
  mediaURL,
  className,
  name,
  type,
  moduleId,
}) => {
  const enhancedClassName = className
    ? `banner-static ${className}`
    : 'banner-static'
  return (
    <div
      className={enhancedClassName}
      data-module={name}
      data-module-name={name}
      data-module-id={moduleId}
      data-module-type={type}
    >
      <a
        className="bannerLink"
        href={link.path}
        data-trackingcode={trackingCode}
      >
        <img src={mediaURL} alt={imageAlt} />
      </a>
    </div>
  )
}

BannerStatic.propTypes = {
  imageAlt: string.isRequired,
  mediaURL: string.isRequired,
  link: shape({
    path: string,
  }),
  trackingCode: string.isRequired,
  className: string,
  name: string,
  moduleId: string,
  type: string,
}

BannerStatic.defaultProps = {
  link: {
    path: '',
  },
  className: '',
  name: null,
  moduleId: null,
  type: null,
}

export default BannerStatic



// WEBPACK FOOTER //
// ./components/banner-static/index.js